import { createContext, useContext } from 'react';
import { VoiceChatState, VoicePhase } from '../services/voiceChat';
import type { VoiceCardGroup } from '../components/F8/VoiceCardOverlay';

export interface VoiceChatContextValue {
  state: VoiceChatState;
  phase: VoicePhase;
  muted: boolean;
  elapsed: number;
  lastError: string | null;
  remainingSeconds: number | null;
  tier: string | null;
  userTranscript: string;
  agentTranscript: string;
  activeCards: VoiceCardGroup[];
  timeWarningSeconds: number | null;
  quotaExhausted: boolean;
  quotaReason: string | null;
  /** The chat thread this voice session wrote its transcript + cards to. */
  voiceThreadId: string | null;
  start: (options?: { threadId?: string | null }) => Promise<void>;
  stop: () => Promise<void>;
  toggleMute: () => void;
  dismissCard: (timestamp: number) => void;
  sendChatHistory: (messages: any[]) => void;
}

// Lives here (not in VoiceChatContext.tsx) so that file exports only the
// provider component and stays Fast Refresh compatible.
export const VoiceChatContext = createContext<VoiceChatContextValue | null>(null);

export function useVoiceChat(): VoiceChatContextValue {
  const ctx = useContext(VoiceChatContext);
  if (!ctx) throw new Error('useVoiceChat must be used within VoiceChatProvider');
  return ctx;
}
